import { useState } from 'react';
import { Button, ConfirmationModalContent, ModalPopup } from 'components';
import { useFormikContext } from 'formik';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useIsOnlyVisibleToUserWithPermissions } from 'utils/hooks/useIsOnlyVisibleTo';
import { PERMISSION } from 'utils/protectedRoutes/userRolesAndPermissionTypes';

import { useNoteFormActions } from '../hooks/useNoteForm';
import { useIsTranscribing } from '../hooks/useIsTranscribing';
import { NoteFormValues } from '../utils/validation';
import style from '../noteEdit.module.scss';

type DeleteButtonProps = {
  confirmTitle?: string;
  confirmText?: string;
  confirmButtonText?: string;
  rejectButtonText?: string;
  isPopup?: boolean;
};

export const DeleteButton = ({
  confirmTitle = 'Are you sure you want to delete your note?',
  confirmText = ' ',
  confirmButtonText = 'Yes, delete',
  rejectButtonText = 'No, return to editing',
  isPopup = false
}: DeleteButtonProps) => {
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const { handleDelete } = useNoteFormActions({ isPopup });
  const { aiScribe: enableAiScribe } = useFlags();
  const isTranscribing = useIsTranscribing();
  const formik = useFormikContext<NoteFormValues>();
  const canUpdateManagerReview = useIsOnlyVisibleToUserWithPermissions([
    PERMISSION.UPDATE_MANAGER_REVIEW
  ]);

  const isDisabled =
    (enableAiScribe && isTranscribing) ||
    (!canUpdateManagerReview && formik.values.noteType === 'MANAGER_REVIEW');

  const handleConfirm = async () => {
    await handleDelete();
    setShowConfirmationModal(false);
  };

  return (
    <>
      <Button
        text=""
        type="button"
        disabled={isDisabled}
        icon={<span className="material-icons">delete</span>}
        handleOnClick={() => setShowConfirmationModal(true)}
        customStyleClass={style.actionButton}
      />
      <ModalPopup open={showConfirmationModal} handleClose={() => setShowConfirmationModal(false)}>
        <ConfirmationModalContent
          confirmButtonText={confirmButtonText}
          rejectButtonText={rejectButtonText}
          title={confirmTitle}
          customClassInsideContainer={style.deleteNoteModal}
          text={confirmText}
          handleConfirm={handleConfirm}
          handleReject={() => setShowConfirmationModal(false)}
        />
      </ModalPopup>
    </>
  );
};
